'use client'
import React, { useEffect, useRef } from 'react'
import { useFormConfigContext } from 'src/components/era-package/forms/hooks/useFormConfig'

export const Interceptor = ({ setActiveTab, setFetchedData, fetchedData }) => {
  const isFirstLoad = useRef(true)
  const rhf = useFormConfigContext()
  const docType = rhf.watch('selectDoc.docType')
  const response = rhf.watch('response')

  useEffect(() => {
    if (isFirstLoad) setActiveTab(1)
  }, [])

  useEffect(() => {
    if (docType !== undefined && docType !== '') {
      rhf.setValue("response", undefined);
      setActiveTab(2)
    }
  }, [docType])

  useEffect(() => {
    console.log(response)
    if (response?.referenceNumber !== undefined && response?.referenceNumber !== '' && docType !== undefined && docType !== '')
      setActiveTab(3)
    else if (response?.referenceNumber !== undefined && response?.referenceNumber !== '')
      setActiveTab(2)
  }, [response])

  return <></>
}
